export const ExemptionStatuses = Object.freeze({
  Sometida: 1,
  Aprobada: 2,
  Denegada: 3,
});
